import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function QuestionDialog({ value, cats, onClose, onSave }) {
  const [q, setQ] = useState(value);
  useEffect(() => setQ(value), [value]);
  if (!q) return null;
  return (
    <Dialog open={!!value} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-2xl" data-testid="question-dialog">
        <DialogHeader><DialogTitle className="font-cabinet text-white text-2xl">{q.id ? "Edit question" : "New question"}</DialogTitle></DialogHeader>
        <div className="space-y-5">
          <div>
            <Label className="text-xs text-slate-400">Category</Label>
            <Select value={q.category} onValueChange={(c) => setQ({ ...q, category: c })}>
              <SelectTrigger className="mt-2 bg-slate-950 border-slate-800" data-testid="question-category-select"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-slate-900 border-slate-800">{Object.entries(cats).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs text-slate-400">Question (the officer will phrase it naturally)</Label>
            <Textarea value={q.text} onChange={(e) => setQ({ ...q, text: e.target.value })} rows={3} className="mt-2 bg-slate-950 border-slate-800" data-testid="question-text-input" />
          </div>
          <div>
            <Label className="text-xs text-slate-400">Answer framework / evaluation guidance</Label>
            <Textarea value={q.guidance} onChange={(e) => setQ({ ...q, guidance: e.target.value })} rows={4} className="mt-2 bg-slate-950 border-slate-800" data-testid="question-guidance-input" />
          </div>
        </div>
        <DialogFooter>
          <button onClick={onClose} className="px-5 py-2 text-sm text-slate-400 hover:text-white" data-testid="question-cancel-btn">Cancel</button>
          <button onClick={() => q.text.trim() && onSave(q)} className="px-5 py-2 text-sm bg-blue-600 hover:bg-blue-500 text-white" data-testid="question-save-btn">Save</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
